export const PRODUCT_DROP_IN_DAMPER = {
  label: 'Drop-In Damper',
  value: 'PRODUCT_DROP_IN_DAMPER'
};
